import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import { getAccionesDesarrolloThunk } from "../store/reducers/fortalezas/fortalezas.thunks";
import AccionesHeader from "./fortalezas/AccionesHeader";
import AccionesTable from "./fortalezas/AccionesTable";
import AccionViewModal from "./fortalezas/AccionViewModal";
import AccionFormModal from "./fortalezas/AccionFormModal";
import AccionMultiplesModal from "./fortalezas/AccionMultiplesModal";
import ConfirmToggleAccionModal from "./fortalezas/ConfirmToggleAccionModal";
import Loader from "./UI/Loader";
import Alert from "./UI/Alert";
import Pagination from "./UI/Pagination";
import EmptyState from "./UI/EmptyState";
import {
  clearAccionesError,
  setAccionesPage,
} from "../store/reducers/fortalezas/fortalezas.reducer";

const FortalezasAccionesListLayer = () => {
  const dispatch = useDispatch();
  const {
    accionesList,
    accionesLoading,
    accionesError,
    accionesPage,
    accionesPageSize,
    accionesSearch,
    accionesFilterArea,
    accionesFilterTalento,
    accionesCount,
  } = useSelector((state) => state.fortalezas);

  useEffect(() => {
    dispatch(
      getAccionesDesarrolloThunk({
        page: accionesPage,
        search: accionesSearch,
        area: accionesFilterArea,
        talento: accionesFilterTalento,
      })
    );
  }, [dispatch, accionesPage, accionesSearch, accionesFilterArea, accionesFilterTalento]);

  return (
    <div className="card p-0 radius-12">
      <div className="card-body p-24">
        <AccionesHeader />

        {accionesError && (
          <Alert
            message={accionesError}
            variant="error"
            onClose={() => dispatch(clearAccionesError())}
          />
        )}

        {accionesLoading ? (
          <Loader center text="Cargando acciones de desarrollo..." delay={200} />
        ) : (
          <>
            {accionesSearch && (
              <div className="mb-3 d-flex align-items-center gap-2 text-secondary-light">
                <Icon icon="mdi:information-outline" width="18" />
                <span className="text-sm">
                  {accionesCount > 0 ? (
                    <>
                      Se {accionesCount === 1 ? "encontró" : "encontraron"}{" "}
                      <strong className="text-primary">{accionesCount}</strong>{" "}
                      {accionesCount === 1 ? "resultado" : "resultados"} para "
                      {accionesSearch}"
                    </>
                  ) : (
                    <>No se encontraron resultados para "{accionesSearch}"</>
                  )}
                </span>
              </div>
            )}

            {accionesList.length === 0 ? (
              <EmptyState
                icon={accionesSearch ? "mdi:magnify-remove-outline" : "mdi:lightbulb-outline"}
                title={accionesSearch ? "No se encontraron acciones" : "No hay acciones de desarrollo registradas"}
                description={accionesSearch ? "Intenta con otra búsqueda" : 'Haz clic en "Agregar acción" para crear una nueva'}
              />
            ) : (
              <>
                <AccionesTable acciones={accionesList} search={accionesSearch} />
                <Pagination
                  page={accionesPage}
                  count={accionesCount}
                  pageSize={accionesPageSize}
                  onPageChange={(newPage) => dispatch(setAccionesPage(newPage))}
                />
              </>
            )}
          </>
        )}
      </div>

      <AccionViewModal />
      <AccionFormModal />
      <AccionMultiplesModal />
      <ConfirmToggleAccionModal />
    </div>
  );
};

export default FortalezasAccionesListLayer;
